import { Navigate, isRouteErrorResponse, useRouteError } from "react-router-dom";
import { useAuth } from "../auth/Auth";
import { useEffect } from "react";

export default function ErrorBoundary() {
    const { onLogout } = useAuth();
    const error = useRouteError();

    useEffect(() => {
        if ((isRouteErrorResponse(error) && error.status === 401) || error?.response?.status === 401) {
            onLogout();
        }
    }, [error, onLogout]);

    if (isRouteErrorResponse(error)) {
        // If we get unauthenticated error, we redirect to login page
        if (error.status === 401) {
            return <Navigate to={"/login"} />;
        }

        // If we get different error, we redirect to error page
        return <Navigate to={"/error"} />;
    }

    // If we get unauthenticated error, we redirect to login page
    if (error?.response?.status === 401) {
        return <Navigate to={"/login"} />;
    }

    // If we get different error, we redirect to error page
    return <Navigate to={"/error"} />;
}
